import React, { useContext, useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { AuthContext } from "../App";
import envConfig from "../envConfig";
function Header() {
  const { isAuthenticated, logout } = useContext(AuthContext);
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [profileImage, setProfileImage] = useState("default_user.png");
  // Get userDetails from localStorage
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
  useEffect(() => {
    // Handle username with null/empty last_name
    const firstName = userDetails?.first_name || "User";
    const lastName = userDetails?.last_name && userDetails.last_name !== "null" ? ' ' + userDetails.last_name : "";
    setUsername(`${firstName} ${lastName}`.trim());
    if (userDetails?.profile_image) {
      setProfileImage(userDetails.profile_image);
    }
  }, [isAuthenticated, userDetails]);
  // Custom Dropdown Toggle with Profile Image
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="d-flex align-items-center btn btn-link text-dark text-decoration-none p-2 rounded"
      role="button"
      aria-label={`User menu for ${username}`}
      data-bs-toggle="tooltip"
      data-bs-placement="bottom"
      title="Open user menu"
    >
      <img
        src={
          profileImage.startsWith("data:")
            ? profileImage
            : `${envConfig.API_URL}/profishblue_media/profile_images/${profileImage}`
        }
        alt={`${username}'s profile`}
        className="rounded-circle me-2 img-fluid"
        style={{ width: "32px", height: "32px", objectFit: "cover" }}
        onError={() => setProfileImage("default_user.png")} // Fallback for broken images
      />
      <span className="fw-medium">Welcome, {username}</span>
      <i className="bi bi-caret-down-fill ms-2"></i>
    </div>
  ));
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light p-0 fixed-top">
      <div className="container-fluid">
        <NavLink className="navbar-brand" to="/" aria-label="Home">
          <div className="d-flex justify-content-start align-items-center">
            <div> <img
              src="/assets/images/worldfish-logo.svg"
              loading="lazy"
              alt="Logo"
              height="40"
            /></div>
            <div className="vl"></div>
            <div><h4 className="nav-title mb-0">Blue Resilience / Ulimi Wansomba</h4></div>
          </div>
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto">
            {isAuthenticated && (
              <>
                <li className="nav-item">
                  <NavLink
                    className="nav-link px-3"
                    to="/"
                    style={({ isActive }) => ({
                      fontWeight: isActive ? "600" : "normal",
                      color: isActive ? "#58ab53" : "inherit",
                    })}
                  >
                    Advisory
                  </NavLink>
                </li>
                <NavLink
                  className="nav-link px-3"
                  to="/dashboard"
                  style={({ isActive }) => ({
                    fontWeight: isActive ? "600" : "normal",
                    color: isActive ? "#58ab53" : "inherit",
                  })}
                >
                  Dashboard
                </NavLink>
                <li className="nav-item">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant=""
                      id="dropdown-maps"
                      className="nav-link text-dark px-3"
                      style={{
                        fontWeight: ["/risk-map", "/analytics/fao-asis"].some(p => location.pathname.startsWith(p)) ? "600" : "normal",
                        color: ["/risk-map", "/analytics/fao-asis"].some(p => location.pathname.startsWith(p)) ? "#58ab53" : "inherit",
                      }}
                    >
                      Maps
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item as={NavLink} to="/risk-map">
                        Risk Map
                      </Dropdown.Item>
                      <Dropdown.Item as={NavLink} to="/analytics/fao-asis">
                        Analytics: FAO-ASIS
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
                {userDetails.role_id <= 4 && (
                  <li className="nav-item">
                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        id="dropdown-setup"
                        className="nav-link text-dark px-3"
                      >
                        Set Up
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        {/* <Dropdown.Item as={NavLink} to="/advisory-management">
                          Advisory Management
                        </Dropdown.Item>*/}
                        <Dropdown.Item as={NavLink} to="/fisherman">
                          Fish Farmers
                        </Dropdown.Item>
                        <Dropdown.Item as={NavLink} to="/extension-officer">
                          Extension Officers
                        </Dropdown.Item>
                        <Dropdown.Item as={NavLink} to="/locations">
                          Location
                        </Dropdown.Item>
                        {/*<Dropdown.Item as={NavLink} to="/threshold">
                          Threshold
                        </Dropdown.Item>*/}
                        {userDetails.role_id === 1 && (
                          <Dropdown.Item as={NavLink} to="/user-management">
                            Users
                          </Dropdown.Item>
                        )}
                        {userDetails.role_id === 1 && (
                          <Dropdown.Item as={NavLink} to="/registered-users">
                            Self Registered Users
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>
                )}
                <li className="nav-item">
                  <NavLink
                    className="nav-link px-3"
                    to="/about-us"
                    style={({ isActive }) => ({
                      fontWeight: isActive ? "600" : "normal",
                      color: isActive ? "#58ab53" : "inherit",
                    })}
                  >
                    About Us
                  </NavLink>
                </li>
              </>
            )}
          </ul>
          <ul className="navbar-nav ms-auto">
            {isAuthenticated ? (
              <li className="nav-item">
                <Dropdown>
                  <Dropdown.Toggle as={CustomToggle} id="dropdown-profile" />
                  <Dropdown.Menu align="end" className="p-3">
                    <div className="border-bottom pb-2 mb-2">
                      <div className="d-flex align-items-center">
                        <img
                          src={
                            profileImage.startsWith("data:")
                              ? profileImage
                              : `${envConfig.API_URL}/profishblue_media/profile_images/${profileImage}`
                          }
                          alt={`${username}'s profile`}
                          className="rounded-circle me-2 img-fluid"
                          style={{ width: "40px", height: "40px", objectFit: "cover" }}
                        />
                        <div>
                          <div className="fw-semibold">{username}</div>
                          <div className="text-muted small">{userDetails.email}</div>
                        </div>
                      </div>
                    </div>
                    <Dropdown.Item as={NavLink} to="/profile" className="py-2">
                      <i className="bi bi-person me-2"></i> Profile
                    </Dropdown.Item>
                    <Dropdown.Item onClick={logout} className="py-2 text-danger">
                      <i className="bi bi-box-arrow-right me-2"></i> Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </li>
            ) : (
              location.pathname !== "/login" && (
                <li className="nav-item">
                  <NavLink className="nav-link btn btn-outline-primary px-3" to="/login">
                    Login
                  </NavLink>
                </li>
              )
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}
export default Header;